import { Badge } from "@/components/ui/badge";
import { CheckCircle, XCircle } from "lucide-react";

const ProductAvailabilityBadge = ({ isAvailable }) => {
  return isAvailable ? (
    <Badge variant="default" className="bg-green-100 text-green-700 border border-green-300">
      <CheckCircle className="w-4 h-4 mr-1" />
      Disponible
    </Badge>
  ) : (
    <Badge variant="outline" className="bg-red-100 text-red-700 border border-red-300">
      <XCircle className="w-4 h-4 mr-1" />
      Indisponible
    </Badge>
  );
};

export default ProductAvailabilityBadge;
